module.exports = __webpack_public_path__ + "img/logo.224cffe8.png";